import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

/**
 * Wraps Vue Router - push() and replace()
 */

['push', 'replace'].forEach(method => {
  const originalMethod = VueRouter.prototype[method];
  VueRouter.prototype[method] = function m (location) {
    return originalMethod.call(this, location).catch(error => {
      if (error.name !== 'NavigationDuplicated' || location.name !== 'appIndex') {
        throw error;
      }
    });
  };
});

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: { name: 'appIndex' }
  },
  {
    path: '/confirm',
    name: 'confirm-redirect',
    redirect: { name: 'confirm-sign-up' }
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import(/* webpackChunkName: 'auth' */ './views/Auth/index.vue'),
    children: [
      {
        path: 'sign-in',
        name: 'sign-in',
        component: () => import(/* webpackChunkName: 'sign-in' */ './views/Auth/SignIn/SignIn.vue')
      },
      {
        path: 'sign-in/info',
        name: 'sign-in-info',
        component: () => import(/* webpackChunkName: 'sign-in-info' */ './views/Auth/SignIn/Info.vue')
      },
      {
        path: 'sign-in/disclaimers',
        name: 'sign-in-disclaimers',
        component: () => import(/* webpackChunkName: 'sign-in-disclaimers' */ './views/Auth/SignIn/Disclaimers.vue')
      },
      {
        path: 'sign-up',
        name: 'sign-up',
        component: () => import(/* webpackChunkName: 'sign-up' */ './views/Auth/SignUp.vue')
      },
      {
        path: 'confirm',
        name: 'confirm-sign-up',
        component: () => import(/* webpackChunkName: 'confirm-sign-up' */ './views/Auth/ConfirmSignUp.vue')
      },
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: () => import(/* webpackChunkName: 'forgot-password' */ './views/Auth/ForgotPassword.vue')
      },
      {
        path: 'reset-password',
        name: 'reset-password',
        component: () => import(/* webpackChunkName: 'reset-password' */ './views/Auth/ResetPassword.vue')
      },
      {
        path: 'banned-country',
        name: 'banned-country',
        component: () => import(/* webpackChunkName: 'banned-country' */ './views/Auth/BannedCountry.vue')
      },
      {
        path: 'sso',
        name: 'sso',
        component: () => import(/* webpackChunkName: 'banned-country' */ './views/Auth/RedirectSSO.vue')
      }
    ]
  },
  {
    path: '/app',
    name: 'appIndex',
    component: () => import(/* webpackChunkName: 'appIndex' */ './views/App/index.vue'),
    redirect: { name: 'dashboard' },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: 'dashboard' */ './views/App/Dashboard.vue')
      },
      {
        path: 'profile/:milestoneId',
        name: 'profileRedirect',
        component: () => import(/* webpackChunkName: 'profile' */ './views/App/Profile/index.vue')
      },
      {
        path: 'profile/:milestoneId/:sectionId',
        name: 'profile',
        component: () => import(/* webpackChunkName: 'profile' */ './views/App/Profile/index.vue')
      }
    ]
  },
  {
    path: '*',
    name: 'notFound',
    redirect: { name: 'appIndex' }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
